/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import Title from 'components/shared/title/title';
import BodyCopy from 'components/shared/bodycopy/bodycopy';
import Loader from 'components/shared/loader/loader';

// STYLES
import styles from 'components/content/userdatacollection/phases/udcfetching/udcfetching_styles';
import { createStyles } from 'utils/styles';
const sheet = createStyles(styles, { link:false });



/* ========== ~~~~~~~~~~ SER DATA COLLECTION SUCCESS PHASE: CHILD ~~~~~~~~~~ ========== */
const UDCFetchingPhase = props => (
    <div className={`${sheet.classes.udcsfetching} uniquecontent fetching ${props.phase}`}>
        <Title>{`Fetching Content`}</Title>
        <Loader type={'ellipsis'} />
        <BodyCopy>
            <p>Hang on! We'll have more for you momentarily.</p>
        </BodyCopy>
    </div>
);



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default UDCFetchingPhase;
